<script>
import { mapActions, mapState } from 'vuex';
import ItineraryPricesWrapper from '../../components/itinerary/itineraryPrices/ItineraryPricesWrapper';

export default {
  name: 'ItineraryPrices',
  components: {
    ItineraryPricesWrapper,
  },
  created() {
    this.getCarriers();
    this.getTransits();
    const payload = { itineraryId: this.$route.params.id, domainId: this.$route.params.domainId };
    this.getItineraryPriceIntervals(payload);
    this.getItineraryDayProgram(payload.itineraryId);
    this.getCarRentalSuppliers();
  },
  computed: {
    ...mapState({
      transits: state => state.nonDynamicTransport.transits.items,
      carriers: state => state.nonDynamicTransport.carriers.items,
      itineraryPriceIntervals: state => state.itinerary.priceIntervals.items,
      itineraryPriceIntervalsLoading: state => state.itinerary.priceIntervals.loading,
      dayProgram: state => state.itinerary.pricesDayProgram.items,
      dayProgramLoading: state => state.itinerary.pricesDayProgram.loading,
    }),
  },
  methods: {
    ...mapActions({
      getCarriers: 'nonDynamicTransport/getCarriers',
      getTransits: 'nonDynamicTransport/getTransitsByType',
      getItineraryPriceIntervals: 'itinerary/getItineraryPriceIntervals',
      getItineraryDayProgram: 'itinerary/getItineraryDayProgram',
      getCarRentalSuppliers: 'itinerary/getCarRentalSuppliers',
    }),
  },
};
</script>

<template>
  <div class="mt-3">
    <div class="text-xs-center">
      <v-progress-circular
        v-if="itineraryPriceIntervalsLoading || dayProgramLoading || !dayProgram.length"
        color="primary"
        indeterminate
      />
    </div>
    <itinerary-prices-wrapper
      v-if="!itineraryPriceIntervalsLoading && !dayProgramLoading && dayProgram.length"
      :itinerary-price-intervals="itineraryPriceIntervals"
      :transits="transits"
      :carriers="carriers"
      :day-program="dayProgram"
    />
  </div>
</template>



// WEBPACK FOOTER //
// src/pages/itinerary/ItineraryPrices.vue